<template>
<!-- FOOTER (HTML identique à ton footer actuel) -->
  <footer class="footer">
    <div class="footer-inner">

      <div class="footer-ctaCard">
        <div class="footer-ctaLeft">
          <div class="footer-ctaTitle">
            Vous êtes un refuge ?
            <span class="footer-hl">On crée votre site gratuitement.</span>
          </div>
          <p class="footer-ctaText">
            <strong>Hébergement inclus</strong>, <strong>sans publicité</strong>, et vos animaux gagnent une
            <strong>double visibilité</strong> (site du refuge + Asso-Refuge).
          </p>

          <div class="footer-badges" aria-label="Engagements du projet">
            <span class="footer-badge"><span class="dot"></span> 100% gratuit</span>
            <span class="footer-badge"><span class="dot"></span> Hébergement inclus</span>
            <span class="footer-badge"><span class="dot"></span> Sans publicité</span>
          </div>
        </div>

        <div class="footer-ctaRight">
          <RouterLink to="/contact" class="nav-link footer-btn primary">Devenir refuge partenaire</RouterLink>
          <RouterLink to="/contact" class="nav-link footer-btn ghost">Nous contacter</RouterLink>
        </div>
      </div>

      <div class="footer-grid">
        <div class="footer-brand">
          <div class="footer-logo">
            <span class="dot"></span>
            <span>Asso-Refuge</span>
          </div>
          <p class="footer-desc">
            Plateforme indépendante pour centraliser les animaux à l’adoption et offrir aux refuges
            un site moderne <span class="footer-hl">gratuit</span> (hébergement inclus, sans pub).
          </p>
        </div>

        <div class="footer-col">
          <h4>Découvrir</h4>
          <ul>
          <li>  <RouterLink to="/animaux" >Animaux à l’adoption</RouterLink></li>
        <li> <RouterLink to="/refuges" >Refuges partenaires</RouterLink></li>
        <li><RouterLink to="/projet" >Le projet</RouterLink></li>
        <li> <RouterLink to="/contact" >Sponsors</RouterLink></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Partenariats</h4>
          <ul>
            <RouterLink to="/contact" class="nav-link highlight">Devenir refuge partenaire</RouterLink>
            <li> <RouterLink to="/contact">Devenir sponsor</RouterLink></li>
            <li> <RouterLink to="/contact">Contact</RouterLink></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4>Contact</h4>
          <ul>
            <li><a href="mailto:lesrefuges.animalier@gmail.com ">lesrefuges.animalier@gmail.com </a></li>
            <li>          <RouterLink to="/rgpd" class="nav-link">Mentions légales & RGPD</RouterLink>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-bottom">
        <p>© 2026 Asso-Refuge — Projet indépendant, sans publicité.</p>
        <div class="footer-bottomLinks">
          <RouterLink to="/rgpd" class="nav-link">Mentions légales & RGPD</RouterLink>
          <span class="sep">•</span>
          <RouterLink to="/contact" >Contact</RouterLink>
        </div>
      </div>

    </div>
  </footer>

  <!-- BOTTOM NAV (mobile) -->
<nav class="bottom-nav" aria-label="Navigation">
  <RouterLink to="/" class="nav-link">
    <i class="fas fa-home"></i>
    <span>Accueil</span>
  </RouterLink>

  <RouterLink to="/animaux" class="nav-link">
    <i class="fas fa-paw"></i>
    <span>Animaux</span>
  </RouterLink>

  <RouterLink to="/refuges" class="nav-link">
    <i class="fas fa-warehouse"></i>
    <span>Refuges</span>
  </RouterLink>

  <RouterLink to="/projet" class="nav-link">
    <i class="fas fa-lightbulb"></i>
    <span>Le projet</span>
  </RouterLink>

  <RouterLink to="/faq" class="nav-link">
    <i class="fas fa-question-circle"></i>
    <span>F.A.Q</span>
  </RouterLink>

     <a href="https://www.paypal.com/donate?token=VExobUTVWFhuzLMF127IjGzOpaliqnjoYlFmjLjsaX3oLXWUCyadjj5QUU10hve5q1BP6k8_pflzmZ_k&locale.x=FR" class="nav-link">
    <i class="fas fa-question-circle"></i>
    <span>Don</span>
     </a>
</nav>

</template>